import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserRole } from '@shared/models/user-roles';

export const authGuard: CanActivateFn = async (_route, _state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Wait for OAuth initialization to complete
  console.debug('AuthGuard: Waiting for initialization...');
  await authService.waitForInitialization();
  console.debug('AuthGuard: Initialization complete');

  console.debug(
    'AuthGuard: Checking authentication, isAuthenticated:',
    authService.isAuthenticated()
  );

  if (authService.isAuthenticated()) {
    return true;
  }

  // Redirect to login page
  console.debug('AuthGuard: Not authenticated, redirecting to login');
  router.navigate(['/login']);
  return false;
};

export const loginGuard: CanActivateFn = (_route, _state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    return true;
  }

  // Redirect to dashboard if already authenticated
  router.navigate(['/dashboard']);
  return false;
};

export const roleGuard: CanActivateFn = async (route: ActivatedRouteSnapshot, _state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  await authService.waitForInitialization();

  if (!authService.isAuthenticated()) {
    router.navigate(['/login']);
    return false;
  }

  const requiredRoles = route.data['roles'] as UserRole[] | undefined;

  if (!requiredRoles || requiredRoles.length === 0) {
    return true;
  }

  if (authService.hasAnyRole(requiredRoles)) {
    return true;
  }

  console.warn('RoleGuard: User does not have required roles:', requiredRoles);
  router.navigate(['/dashboard']);
  return false;
};
